/* eslint-disable import/prefer-default-export */
import * as types from '../../../constants/types/procurement/ProcurementTypes';
import * as load from '../../../constants/types/shared/LoadingTypes';

export const retrievalsReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case load.LOADING_STARTS:
      return {
        ...state,
        isLoading: true,
      };

    case load.LOADING_STOPS:
      return {
        ...state,
        isLoading: false,
      };

    case types.GET_RETRIEVALS:
      return {
        ...state,
        list: payload.list,
        pages: payload.pages,
        count: payload.count,
        search: payload.search,
        isLoading: false,
      };

    default:
      return state;
  }
};
